import { render, staticRenderFns } from "./ListaEspecialidades.vue?vue&type=template&id=cc72e9a4&scoped=true"
import script from "./ListaEspecialidades.vue?vue&type=script&lang=js"
export * from "./ListaEspecialidades.vue?vue&type=script&lang=js"
import style0 from "./ListaEspecialidades.vue?vue&type=style&index=0&id=cc72e9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc72e9a4",
  null
  
)

export default component.exports